import { axios } from '@/utils/request'
const ipConfig = require('@../../../config/ip.config')

export const downloadApi = ipConfig.upload_oss_api + '/api/Oss/DownloadFile'

export const ClickMenu = (query) => axios({
  url: ipConfig.api_edi + `/api/ReportCenter/ClickMenu`,
  method: 'get',
  params: query
})

export const GetDataStatistics = (query) => axios({
  url: ipConfig.api_edi + `/api/ReportCenter/GetDataStatistics`,
  method: 'get',
  params: query
})

export const GetDataStatisticsJob = (query) => axios({
  url: ipConfig.api_edi + `/api/ReportCenter/GetDataStatisticsJob`,
  method: 'get',
  params: query
})

export const GetDataStatisticsWeight = (query) => axios({
  url: ipConfig.api_edi + `/api/ReportCenter/GetDataStatisticsWeight`,
  method: 'get',
  params: query
})

export const GetDataStatisticsAIJob = (query) => axios({
  url: ipConfig.api_edi + `/api/ReportCenter/GetDataStatisticsAIJob`,
  method: 'get',
  params: query
})

export const GetOrderPage = (data) => axios({
  url: ipConfig.api_edi + `/api/ReportCenter/GetOrderPage`,
  method: 'post',
  data
})

export const GetAttachmentList = (data) => axios({
  url: ipConfig.api_edi + `/api/ReportCenter/GetAttachmentList`,
  method: 'post',
  data
})

export const GetTokenByOss = (query) => axios({
  url: ipConfig.api_edi + `/api/ReportCenter/GetTokenByOss`,
  method: 'get',
  params: query
})

export const GetAirProts = (query) => axios({
  url: ipConfig.api_edi + `/api/ReportCenter/GetAirProts`,
  method: 'get',
  params: query
})
